type EnPatientTrendsTranslations = {
  trends: {
    parameterTrendChart: {
      title: string;
      beta: string;
    };
    series: {
      activeRecordings: string;
      passiveRecordings: string;
      measurements: string;
      distance: string;
    };
    norm: {
      normalRange: string;
    };
    tooltip: {
      activeRecording: string;
      passiveRecording: string;
      measurement: string;
      score: string;
      tags: string;
    };
    filters: {};
    emptyState: {};
    emptyFilterState: {};
  };
};

export const enPatientTrendsTranslations: EnPatientTrendsTranslations = {
  trends: {
    parameterTrendChart: {
      title: 'Trends',
      beta: 'Beta',
    },
    series: {
      activeRecordings: 'Active recordings',
      passiveRecordings: 'Passive recordings',
      measurements: 'Measurements',
      distance: 'Distance',
    },
    norm: {
      normalRange: 'Normal range',
    },
    tooltip: {
      activeRecording: 'Active recording',
      passiveRecording: 'Passive recording',
      measurement: 'Measurement',
      score: 'Score',
      tags: 'Tags',
    },
    filters: {
      showActiveWalks: 'Show active recordings',
      showBgWalks: 'Show passive recordings',
      showClinicalEvents: 'Show clinical events',
      tooltip: {
        bgWalks:
          'Passive recordings reflect real-world walking automatically detected from daily activity. They’re typically slightly lower than Active Walks (intentional measurements), with an expected difference of about 10%.',
        emptyBgWalks: 'No passive recordings in the selected time range',
        clinicalEvents:
          'Clinical events are key occurrences like surgery or falls that impact mobility and help explain changes in gait.',
        emptyClinicalEvents: 'No clinical events in the selected time range',
        activeWalks: 'Active Walks are intentional measurements performed in the mobile app.',
        emptyActiveWalks: 'No active walks in the selected time range',
      },
    },
    emptyState: {
      title: 'No measurements taken',
      description: 'Start taking measurements to assess fall risk and track progress over time',
    },
    emptyFilterState: {
      title: 'No data to display',
      description:
        'Try adjusting the filters, expanding the date range, or turning on passive recordings to see more',
    },
  },
};
